let module = angular.module('app.resources');

module.factory('AppleTvApp', ($resource) => {
  'ngInject';

  return $resource(
    `${API_ROOT}/account/apple_tv_apps/:id`,
    { id: '@id' },
    {
      update: {
        method: 'PUT',
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/apple_tv_app.js